import type { PropertySelectionRow } from "../../types";

/** 地図クリック・住所検索で立てた青ピン（ポップアップ）が表している物件 */
export interface MapClickPinIdentifier {
  prefName: string;
  location: string;
  chiban: string;
}

/**
 * 物件一覧の行が、いま地図に立っているクリック地点の青ピンの物件かどうか。
 * 地図クリックで追加した行（pinType が map-click）のうち、都道府県・所在・地番が一致するもの
 */
export const isRowOfMapClickPin = (
  row: PropertySelectionRow,
  identifier: MapClickPinIdentifier | null | undefined
): boolean =>
  !!identifier &&
  row.pinType === "map-click" &&
  row.prefName === identifier.prefName &&
  row.location === identifier.location &&
  row.chibanKaokuNumber === identifier.chiban;
